<template>
    <div>
<v-dialog
      v-model="dialog"
      width="500"
    >
    
      <template v-slot:activator="{ on, attrs }">
        <v-btn  class="ma-2 secondary" v-bind="attrs" v-on="on" >
             <v-icon left>fa fa-calendar</v-icon>
                <span>Horários</span>
        </v-btn>
        

      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Escolha horários para {{ barbeiro.nome }}
        </v-card-title>

        <div >
                 <v-form class="pa-5" ref="form" >
                    
                <v-card>
                  
                  <v-toolbar-title class="px-5" >Configure horário de início e fim</v-toolbar-title>
                  
                
            <v-layout row justify-center class="px-8"  >
                
                
                <v-flex xs12>
                    <v-row v-for="item in semana" :key="item.dia" class="grey lighten-3 my-3">
                        <v-col cols="12">
                          <v-card class="pa-2"><span>{{item.dia }}</span></v-card>
                        </v-col>

                      <v-col cols="6" sm="6" >
                         
                         <v-text-field  type="time" v-model="item.horaIni" label="Abertura" ></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" >
                         <v-text-field  type="time" label="Fechamento" v-model="item.horaFim" ></v-text-field>
                      </v-col>
                      
                      <v-row justify="center">
                        <v-col cols="10" ><v-card class="pa-2 indigo lighten-5" style="margin-top:-20px" ><span>Defina horário de almoço</span></v-card></v-col>
                       <v-col cols="5" sm="5" >
                          <v-text-field type="time" v-model="item.almocoIni" label="Saída" ></v-text-field>
                        </v-col>
                        <v-col cols="5" sm="5" >
                          <v-text-field type="time" label="Volta" v-model="item.almocoFim" ></v-text-field>
                        </v-col>
                      
                      </v-row>
                    </v-row>  

                </v-flex>
    
            </v-layout>

            </v-card>
                </v-form>
        </div>

        <divider></divider>
    
        <v-card-actions>
          <v-spacer></v-spacer>
          
          <v-btn  color="primary" text @click="atualizarHorarios" >
            Atualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
import { refBarbeiros} from '@/firebaseConfig'


    export default {
        props: ['barbeiro'],
        data(){
            return {
                semana: [
                    {diaNumber: 0, dia: 'Segunda', horaIni: '', horaFim: '', almocoIni: '', almocoFim: ''}, //SEGUNDA
                    {diaNumber: 1, dia: 'Terça', horaIni: '', horaFim: '', almocoIni: '', almocoFim: ''}, //TERÇA
                    {diaNumber: 2, dia: 'Quarta', horaIni: '', horaFim: '', almocoIni: '', almocoFim: ''}, //QUARTA
                    {diaNumber: 3, dia: 'Quinta', horaIni: '', horaFim: '', almocoIni: '', almocoFim: ''}, //QUINTA
                    {diaNumber: 4, dia: 'Sexta', horaIni: '', horaFim: '', almocoIni: '', almocoFim: ''}, //SEXTA
                    {diaNumber: 5, dia: 'Sábado', horaIni: '', horaFim: '', almocoIni: '', almocoFim: ''}, //SABADO
                    {diaNumber: 6, dia: 'Domingo', horaIni: '', horaFim: '', almocoIni: '', almocoFim: ''}, //DOMINGO
                    //{estadoUm: false, estadoDois: false, diaNumber: 7, dia: 'Feriados'}, //DOMINGO
                    
                ],
                dialog: false,
                refBarbeiro: refBarbeiros,
                
            }
        },
        created(){
            this.gerarHorarios()
        },
        methods: {
           
            gerarHorarios(){
              /*let quarterHours = ["00", "05", "10", "15", "20", "25","30", "35", "40", "45","50","55"]
                for(let i = 6; i < 24; i++){
                    let stringHour = '';
                    
                    quarterHours.forEach(quart =>{
                      stringHour =  i < 10 ? `0${i}:${quart}` : `${i}:${quart}`
                      this.horariosUm.push(stringHour)
                    });
                    
                 
                    
                }*/
                
                if(this.barbeiro.horarios){
                  this.semana = this.barbeiro.horarios;
                 // console.log(this.barbeiro.horarios);
                }
                
              
                
            },

           
            atualizarHorarios(){
                this.refBarbeiro.doc(this.barbeiro.id).update({horarios: this.semana}).then(()=>{
                    this.$emit("recarregarLista");
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>